import { AppGrid } from 'components/AppGridLayout/AppGrid'
import React, { useState } from 'react'
import { initPageId, initPageMode } from '../../../utils/index'
import { GridDemoData } from './GridDemoData'

export const Grid = () => {
  const [customerData, setCustomerData] = useState({ disabled: 0, organ_id: 0 })
  const [mode, setMode] = useState(initPageMode())
  const [keyValue, setKeyValue] = useState(initPageId())
  const refAppForm = React.useRef()

  const saveForm = () => {
    if (typeof refAppForm.current === 'undefined') {
      return
    }
    ; (refAppForm.current as any).saveForm && (refAppForm.current as any).saveForm()
  }

  const FormDemoActionData = [
    { title: '保存', id: 'btnSave', type: 'primary', action: saveForm },
    { title: '取消', id: 'btnCancel', type: 'default' },
    { title: '重置', id: 'btnReset', type: 'default' },
  ]

  return (
    <AppGrid
      {...GridDemoData}
    />
  )
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/Grid.tsx